import { render, staticRenderFns } from "./PolicyDocuments.vue?vue&type=template&id=e96c4acc&"
import script from "./PolicyDocuments.vue?vue&type=script&lang=js&"
export * from "./PolicyDocuments.vue?vue&type=script&lang=js&"
import style0 from "./PolicyDocuments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports